enum VDP_REDIRECT_PARAM {
  BUY_PENDING = 'pending',
  SELL_PENDING = 'sell-pending'
}

export default VDP_REDIRECT_PARAM;
